import React, { Component } from "react";
import { connect } from "react-redux";
import CustomSelect from "../../components/common/select/Select";
import PostOpsoPratDashboardPieChart from "../../components/pie-charts/postOpsoPratDashPieChart";
import PratDashboardMiddleware from "../../store/prat_middleware/pratDashboard/pratDashboardMiddleware";
import { compare } from "../gt/validation/sort";
import CustomToast from '../../util-functions/customToast.jsx'

class PostOpsoResult extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedCategory: [],
      data: []
    };
  }

  componentDidMount() {
    let arr = [];
    if (this.props.categories) {
      this.props.categories.forEach(item => {
        arr.push(item.guid);
      });
      this.setState(
        {
          selectedCategory: arr
        },
        () => {
          this.handleSubmit();
        }
      );
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.categories !== this.props.categories) {
      let arr = []
      this.props.categories.forEach(item => {
        arr.push(item.guid)
      })
      this.setState({
        selectedCategory: arr
      }, () => {
        this.handleSubmit();
      })
    }
  }

  handleCategory = category => {
    let arr = [];
    if (category === null || category.length === 0) {
      this.setState(
        {
          selectedCategory: []
        },
        () => {
          this.handleSubmit();
        }
      );
    } else {
      category.forEach(element => {
        arr.push(element.value);
      });
      this.setState({ selectedCategory: arr }, () => {
        this.handleSubmit();
      });
    }
  };

  handleSubmit = () => {
    if (this.state.selectedCategory.length) {
      this.props.getPostOpsoResult(this.state.selectedCategory);
    } else {
      // ToastsStore.error("Category is not selected!");
      CustomToast('error', 'Category is not selected!')
    }
  };

  render() {
    return (
      <div
        className="activation-metrics-container"
        style={{ minHeight: "305px" }}
      >
        <div className="activation-metrics-heading-cta">
          <span className="activation-metrics-heading">Post OPSO Results</span>

          <CustomSelect.MyCustomSelect
            className='filter-font-size'
            placeholder={"Category"}
            allowSelectAll={true}
            isMulti
            options={
              this.props.categories
                ? !this.props.categories
                  ? void 0
                  : this.props.categories.sort(compare).map(item => ({
                    value: item.guid,
                    label: item.Name
                  }))
                : []
            }
            onChange={this.handleCategory}
            value={
              this.props.categories
                ? this.props.categories
                  .filter(item => {
                    return !this.state.selectedCategory
                      ? void 0
                      : this.state.selectedCategory.includes(item.guid);
                  })
                  .map(item => {
                    return {
                      value: item.guid,
                      label: item.Name
                    };
                  })
                : void 0
            }
          />

          <div className="cta-container">
            <img
              className="images-style"
              src={require("../../assets/images/refreshArrows.svg")}
              onClick={this.handleSubmit}
              alt=''
            />
            <img
              className="image-transform"
              src={require("../gt/images/dots.png")}
              alt=''
            />
          </div>
        </div>

        {this.props.isPostOpsoResultLoading ? (
          <div style={{ marginTop: "100px" }}>
            {/* Loading */}
            <img
              src={require("../../assets/images/barsLoader.svg")}
              style={{ width: "60px", height: "60px" }}
              alt=''
            />
          </div>
        ) : (
            <div className="post-opso-result-chart-container">
              <div style={{ display: "flex", justifyContent: "space-around" }}>

                {/* Donut Graph Mapping */}

                {this.props?.postOpsoResult.map((item, ind) => (
                  <PostOpsoPratDashboardPieChart data={item} key={ind} />
                ))}
              </div>

              {this.props.postOpsoResult.length ? null : (
                <div style={{ height: "216px" }}></div>
              )}

              {/* Legends */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  fontSize: "12px",
                  fontWeight: "600",
                  marginTop: "28px"
                }}
              >
                <span className="legend-item">
                  <span
                    className="lengend-box"
                    style={{ backgroundColor: "#69be5e" }}
                  ></span>
                  <span>+ROI +INC Vol</span>
                </span>
                <span className="legend-item">
                  <span
                    className="lengend-box"
                    style={{ backgroundColor: "#fe9f4b" }}
                  ></span>
                  <span>-ROI +INC Vol</span>
                </span>
                <span className="legend-item">
                  <span
                    className="lengend-box"
                    style={{ backgroundColor: "#e3565a" }}
                  ></span>
                  <span>-ROI -INC Vol</span>
                </span>
              </div>
            </div>
          )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    postOpsoResult: state.PratDashboardReducer.postOpsoResult,
    isPostOpsoResultLoading: state.PratDashboardReducer.isPostOpsoResultLoading
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getPostOpsoResult: selectedCategory => {
      return dispatch(
        PratDashboardMiddleware.getPostOpsoResult(selectedCategory)
      );
    }
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(PostOpsoResult);
